// Lettura del fragment #handoff=<token> passato da Admin (o da altre app) nella
// navigazione verso il Learner. Va eseguito il più presto possibile nel bootstrap,
// PRIMA del primo render/effect (vedi import in main.tsx): il tracking (services/tracking.ts)
// sanifica solo i query param, non l'hash, quindi il token deve essere rimosso dalla history
// prima che qualunque virtual page view possa leggere window.location.href.
const HANDOFF_HASH_PATTERN = /(?:^|&)handoff=([^&]+)/;

function readAndClearHandoffToken(): string | null {
  if (typeof window === "undefined") return null;
  const { hash } = window.location;
  if (!hash) return null;

  const match = hash.slice(1).match(HANDOFF_HASH_PATTERN);
  if (!match) return null;

  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}${window.location.search}`
  );

  // Evita che stato stale in localStorage (es. sessione/utente di un tenant
  // precedente sullo stesso host, come già gestito per ?seed_session= in
  // router.tsx) contamini il bootstrap della nuova sessione. Va fatto qui,
  // PRIMA che authStore.tsx rehydrati sincronamente da localStorage
  // (recoverAuthStore, eseguito al module-load) — l'equivalente clear in
  // router.tsx gira nel loader, quindi troppo tardi per avere lo stesso effetto.
  localStorage.clear();

  return decodeURIComponent(match[1]);
}

let pendingHandoffToken = readAndClearHandoffToken();

// Consumo one-shot: garantisce che un token monouso non venga riutilizzato
// su render/effect successivi (es. StrictMode, re-render del bootstrap).
export function consumeHandoffToken(): string | null {
  const token = pendingHandoffToken;
  pendingHandoffToken = null;
  return token;
}
